import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import AbsoluteEmpty from 'components/AbsoluteEmpty';
import { getLiteral } from 'utils/getLiteral';

import TemplatesEmptyView from '../TemplatesEmptyView';
import { createMarketingTemplatesLibraryEmptyViewProps } from '../../utils/marketingTemplatesEmptyView';

/** Search with no matching templates (same as main templates list). */
export const MarketingTemplatesSearchEmpty = memo(() => (
    <div className="marketing-templates-list__empty-search">
        <AbsoluteEmpty
            title={getLiteral('title_templates_not_found')}
            subtitle={getLiteral('label_search_templates_not_found')}
            size="small"
        />
    </div>
));

MarketingTemplatesSearchEmpty.displayName = 'MarketingTemplatesSearchEmpty';

/** Empty templates library (same illustration/copy as main list). */
export const MarketingTemplatesLibraryEmpty = memo(({ showCreateCta = true }) => {
    const navigate = useNavigate();
    const emptyViewProps = useCallback(() => {
        return createMarketingTemplatesLibraryEmptyViewProps(navigate, { showCreateCta })();
    }, [navigate, showCreateCta]);

    return <TemplatesEmptyView emptyViewProps={emptyViewProps} />;
});

MarketingTemplatesLibraryEmpty.displayName = 'MarketingTemplatesLibraryEmpty';

MarketingTemplatesLibraryEmpty.propTypes = {
    showCreateCta: PropTypes.bool,
};
